// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"Stats_landingContainer__M0yE2","stats":"Stats_stats___BrmL"};